(function () {
  "use strict";

  class ProductCardATBComponent extends HTMLElement {
    constructor() {
      super();
      this._isConnected = false;
      this._needsRender = false;
      this._renderRAF = null;
      this._lastHTML = null;
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      const originalPriceVal = parseFloat(value?.priceInfo?.originalPrice ?? 0);
      if (this._isConnected) {
        if (originalPriceVal && originalPriceVal !== 0) {
          this._scheduleRender();
        } else {
          this.innerHTML = "";
          this._lastHTML = null;
          this._needsRender = false;
        }
      } else {
        this._needsRender = !!(originalPriceVal && originalPriceVal !== 0);
      }
    }

    connectedCallback() {
      this._isConnected = true;
      if (this._product && this._needsRender) {
        this._scheduleRender();
        this._needsRender = false;
      } else if (this._product && this._lastHTML == null) {
        this._scheduleRender();
      }
    }

    disconnectedCallback() {
      this._isConnected = false;
      if (this._renderRAF) {
        cancelAnimationFrame(this._renderRAF);
        this._renderRAF = null;
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (name === "product" && newVal && newVal !== oldVal) {
        try {
          const parsed = JSON.parse(newVal);
          this.product = parsed;
        } catch (e) {
          // ignore invalid JSON
        }
      }
    }

    _scheduleRender() {
      if (this._renderRAF) cancelAnimationFrame(this._renderRAF);
      this._renderRAF = requestAnimationFrame(() => {
        this._renderRAF = null;
        this._doRender();
      });
    }

    _doRender() {
      if (!this._product) {
        this.innerHTML = "";
        this._lastHTML = null;
        return;
      }
      const originalPriceVal = parseFloat(this._product?.priceInfo?.originalPrice ?? 0);
      if (!(originalPriceVal && originalPriceVal !== 0)) {
        this.innerHTML = "";
        this._lastHTML = null;
        return;
      }

      const getNumericId = (gidOrId) =>
        typeof gidOrId === "string" && gidOrId.includes("/")
          ? gidOrId.split("/").pop()
          : String(gidOrId || "");

      const safeText = (val) => (val == null ? "" : String(val));

      // Get product handle and ID for add button
      const url = this._product?.url || "#";
      const handleURL = new URL(url, window.location.origin);
      const handle = handleURL.pathname.split("/").pop();
      const productId = safeText(this._product?.productId || "");

      // Get variants for sellable data
      const variants = Array.isArray(this._product?.variants)
        ? this._product.variants
        : [];

      // Build sellable mapping for add button
      const sellable = variants
        .map((variant) => {
          const id = getNumericId(variant.id);
          const available = Boolean(variant.availableForSale);
          return `${id}/${available}`;
        })
        .join(",");


      // Minimal HTML with just the add button
      const html = `
        <component-addtocart data-handle="${handle}" data-is-sellable="${sellable}">
          <form method="post" action="/cart/add" id="product_form_${productId}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-product-form>
            <variant-selector class="hidden" data-handle="${handle}"></variant-selector>
            <input type="hidden" name="qty" value="1">
            <addtocart-button data-handle="${handle}" class="flex" data-build-text>
              <button type="submit" class="btn btn-small btn-icon-left inline-flex w-full" name="add" disabled>
                <span class="flex items-center" data-add-to-cart-icon="true">Out of Stock</span>
              </button>
            </addtocart-button>
          </form>
        </component-addtocart>
      `;
      
      if (html !== this._lastHTML) {
        this.innerHTML = html;
        this._lastHTML = html;
      }
    }
  }

  customElements.define("rcc-product-card-atb", ProductCardATBComponent);
})();
